/*
 * Star Rating German Translations
 *
 * This file must be loaded after 'star-rating.js'. Patterns in braces '{}', or
 * any HTML markup tags in the messages must not be converted or translated.
 *
 * NOTE: this file must be saved in UTF-8 encoding.
 *
 * @see http://github.com/kartik-v/bootstrap-star-rating
 * @author Kartik Visweswaran <kartikv2@gmail.com>
 */
(function ($) {
    "use strict";
    $.fn.ratingLocales['de'] = {
        defaultCaption: '{rating}',
        starCaptions: {
            0.5: '0,5',
            1: '1,0',
            1.5: '1,5',
            2: '2,0',
            2.5: '2,5',
            3: '3',
            3.5: '3,5',
            4: '4,0',
            4.5: '4,5',
            5: '5,0'
        },
        clearButtonTitle: 'Zurücksetzen',
        clearCaption: '' //'Nicht Bewertet'
    };
})(window.jQuery);
